import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Dialog, DialogContent, DialogActions, DialogTitle, FormControl, Typography, IconButton, Alert } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ConfigContext from "../../common/context/ConfigContext";
import BStaticDatePicker from "../../common/date/StaticDatePicker";
import { checkItemAvailabilityByDate, checkStoreAvailabilityByDate } from "../../common/util";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export default function FulfillmentOptionsPreCheck(props) {
  const navigate = useNavigate();

  const { product } = props;
  const siteConfig = useContext(ConfigContext);

  const [open, setOpen] = useState(false);

  const [date, setDate] = useState(props.date || "");

  useEffect(() => {
    if (props.date) {
      setDate(props.date);
    }
  }, [props.date]);

  const handleSubmit = (e) => {
    props.onChange({ date: date });
    setOpen(false);
    navigate(props.target);
  };

  const viewUnavailableItems = (e) => {
    props.onChange({ date: date });
    setOpen(false);
  };

  /*const shouldDisableDate = (d) => {
    const dateString = moment(d).format("YYYY-MM-DD");
    if (product) {
      return !(
        checkItemAvailabilityByDate(siteConfig.id, [product], dateString, siteConfig.storeLocations[0]) &&
        checkStoreAvailabilityByDate(siteConfig.id, siteConfig.storeLocations[0], dateString)
      );
    } else {
      return !checkStoreAvailabilityByDate(siteConfig.id, siteConfig.storeLocations[0], dateString);
    }
  };*/
  const shouldDisableDate = (d) => {
    const dateString = moment(d).format("YYYY-MM-DD");
    return !checkStoreAvailabilityByDate(siteConfig.id, siteConfig.storeLocations[0], dateString);
  };

  let isItemAvailable = true;
  if (date && product) {
    isItemAvailable = checkItemAvailabilityByDate(siteConfig.id, [product], date, siteConfig.storeLocations[0]);
  }

  return (
    <>
      <Box
        onClickCapture={(e) => {
          if (!product) {
            e.preventDefault();
            e.stopPropagation();
            setOpen(true);
          } else if (!props.date) {
            e.preventDefault();
            e.stopPropagation();
            setOpen(true);
          }
        }}
        sx={{ display: "inline-block", width: "100%", cursor: props.target ? "pointer" : "default" }}
      >
        {props.children}
      </Box>
      <Dialog open={open} scroll="paper" fullWidth={true} maxWidth="sm">
        <DialogTitle sx={{ position: "relative", pr: 6 }}>
          Pick a Date
          <IconButton aria-label="close" onClick={() => setOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }} size="small">
            <CloseOutlinedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: "0px" }}>
          <Box py={2} sx={{ borderBottom: "1px solid #ccc" }}>
            {date && product ? (
              <Box>
                {isItemAvailable && (
                  <Alert severity="success">
                    {" "}
                    This item is available on {moment(date).format("ddd, MMM D, YYYY")}. Click the button below to continue.
                  </Alert>
                )}
                {!isItemAvailable && (
                  <Alert severity="error">
                    {" "}
                    Sorry, this item is unavailable on {moment(date).format("ddd, MMM D, YYYY")}. Pick a different date or click the button below to
                    see what's available.
                  </Alert>
                )}
              </Box>
            ) : (
              <Typography variant="body1" gutterBottom>
                {props.target
                  ? "This item has limited availability. Please select a date below to check availability."
                  : "Some of our items have limited availability. Please select one of the available dates & click the button below to check availability."}
              </Typography>
            )}
            {props.date && date && props.date !== date && (
              <Alert severity="info"> Please note that changing date will clear your shopping cart.</Alert>
            )}
          </Box>
          <Box sx={{ marginLeft: "-16px" }}>
            <FormControl variant="outlined" fullWidth>
              <BStaticDatePicker
                value={date || ""}
                label={`Date`}
                onChange={(d) => setDate(moment(d).format("YYYY-MM-DD"))}
                disablePast
                required
                shouldDisableDate={shouldDisableDate}
              />
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {isItemAvailable && (
            <Button fullWidth type="submit" variant="contained" color="primary" disabled={!date} onClick={handleSubmit}>
              CONTINUE
            </Button>
          )}
          {!isItemAvailable && (
            <Button fullWidth type="submit" variant="contained" color="primary" disabled={!date} onClick={viewUnavailableItems}>
              VIEW ITEMS AVAILABLE ON {moment(date).format("MMM D")}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
